import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducer';
import { composeWithDevTools } from 'redux-devtools-extension';

// Compose enhancers for Redux DevTools and middleware
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers = composeWithDevTools({ 
  name: 'DoIntake', 
  trace: true
});

// Create store with middleware
export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

